import React, { Component } from "react";
import SEO from "react-seo-component";
import { Col, Container, Row } from "reactstrap";
import AppDownloadLinks from "../../components/common/AppDownloadLinks";

const VEHICLE_CATEGORIES = [
  {
    name: "Mini Bakkie",
    tagline: "Small items & quick pickups",
    price: "From R250",
    image: "https://media.qiktruck.co.za/3d-minivanopen.png",
    tag: null,
    capacity: "0.8 ton",
    examples: "Boxes, single appliances, small parcels",
    link: "/instant-quote?trucktype=minivanopen",
  },
  {
    name: "1 Ton Open Bakkie",
    tagline: "South Africa's favourite workhorse",
    price: "From R350",
    image: "https://media.qiktruck.co.za/3d-1tonopen.png",
    tag: "MOST POPULAR",
    capacity: "1 ton",
    examples: "Fridge, washing machine, mattress, small move",
    link: "/instant-quote?trucktype=1tonopen",
  },
  {
    name: "1 Ton Closed Body",
    tagline: "Weather-proof & secure",
    price: "From R450",
    image: "https://media.qiktruck.co.za/3d-1tonclosed.png",
    tag: null,
    capacity: "1 ton",
    examples: "Electronics, office equipment, fragile items",
    link: "/instant-quote?trucktype=1tonclosed",
  },
  {
    name: "1.5 Ton Open",
    tagline: "More space, still nimble",
    price: "From R550",
    image: "https://media.qiktruck.co.za/3d-1.5tonopen.png",
    tag: null,
    capacity: "1.5 ton",
    examples: "2-seater sofa, gym equipment, building materials",
    link: "/instant-quote?trucktype=1.5tonopen",
  },
  {
    name: "1.5 Ton Covered",
    tagline: "Full coverage for bigger loads",
    price: "From R650",
    image: "https://media.qiktruck.co.za/3d-1.5tonclosed.png",
    tag: "NEW",
    capacity: "1.5 ton",
    examples: "Furniture sets, appliance bundles, inventory",
    link: "/instant-quote?trucktype=1.5tonclosed",
  },
  {
    name: "4 Ton Closed Truck",
    tagline: "Full house moves made easy",
    price: "From R1 200",
    image: "https://media.qiktruck.co.za/3d-4tonclosed.png",
    tag: null,
    capacity: "4 ton",
    examples: "2-bedroom house, office relocation, bulk stock",
    link: "/instant-quote?trucktype=4tonclosed",
  },
  {
    name: "8 Ton Truck",
    tagline: "Commercial & construction grade",
    price: "From R2 500",
    image: "https://media.qiktruck.co.za/3d-8tonclosed.png",
    tag: null,
    capacity: "8 ton",
    examples: "3+ bedroom house, warehouse loads, heavy materials",
    link: "/instant-quote?trucktype=8tonclosed",
  },
  {
    name: "Fridge Truck",
    tagline: "Temperature-controlled transport",
    price: "From R800",
    image: "https://media.qiktruck.co.za/3d-1tonclosedfridge.png",
    tag: "SPECIALIST",
    capacity: "1 ton",
    examples: "Fresh produce, catering, pharmaceuticals",
    link: "/instant-quote?trucktype=1tonclosedfridge",
  },
];

const TESTIMONIALS = [
  {
    name: "Thabo M.",
    location: "Johannesburg, Gauteng",
    text: "Moved my entire flat in one trip with the 4-ton. Driver was on time and so careful with my furniture. Couldn't believe the price - half of what other guys quoted me!",
    rating: 5,
    vehicle: "4 Ton Closed",
  },
  {
    name: "Nomsa K.",
    location: "Cape Town, WC",
    text: "I use QikTruck every month for my online business deliveries. The app makes it so easy to book and track everything. My customers love getting same-day delivery.",
    rating: 5,
    vehicle: "1 Ton Bakkie",
  },
  {
    name: "Sipho D.",
    location: "Durban, KZN",
    text: "Needed an urgent bakkie for construction materials on a Saturday morning. QikTruck had a driver at my door within 90 minutes. Absolute lifesaver!",
    rating: 5,
    vehicle: "1.5 Ton Open",
  },
  {
    name: "Lerato P.",
    location: "Pretoria, Gauteng",
    text: "We moved our entire office - desks, chairs, servers, everything. The team was professional and nothing was damaged. Will definitely use again.",
    rating: 5,
    vehicle: "8 Ton Truck",
  },
];

const STATS = [
  { value: "50,000+", label: "Deliveries completed" },
  { value: "98%", label: "On-time rate" },
  { value: "4.8★", label: "Average rating" },
  { value: "9", label: "Provinces covered" },
];

const HOW_IT_WORKS = [
  {
    step: "01",
    icon: "mdi mdi-truck-outline",
    title: "Pick your vehicle",
    desc: "Choose from bakkies, trucks, and specialist vehicles for any load size.",
    color: "#57B8FF",
    bg: "rgba(87, 184, 255, 0.12)",
  },
  {
    step: "02",
    icon: "mdi mdi-map-marker-radius",
    title: "Set pickup & drop-off",
    desc: "Enter addresses and get an instant, transparent quote - no hidden fees.",
    color: "#34D1BF",
    bg: "rgba(52, 209, 191, 0.12)",
  },
  {
    step: "03",
    icon: "mdi mdi-calendar-clock",
    title: "Choose your time",
    desc: "Book now for same-day delivery or schedule for a date that works for you.",
    color: "#FBB13C",
    bg: "rgba(251, 177, 60, 0.12)",
  },
  {
    step: "04",
    icon: "mdi mdi-check-decagram",
    title: "We handle the rest",
    desc: "A verified driver arrives on time. Track live. Pay securely. Done.",
    color: "#FE6847",
    bg: "rgba(254, 104, 71, 0.12)",
  },
];

const USE_CASES = [
  {
    icon: "mdi mdi-sofa",
    title: "Furniture & Appliances",
    desc: "Moving home or bought something new? We'll get it there safely.",
    image: "https://media.qiktruck.co.za/banners/furniture.jpg",
  },
  {
    icon: "mdi mdi-hammer-wrench",
    title: "Construction & Materials",
    desc: "Sand, bricks, timber, tools - delivered to your site on time.",
    image: "https://media.qiktruck.co.za/banners/materials.jpg",
  },
  {
    icon: "mdi mdi-food-apple",
    title: "Fresh Goods & Catering",
    desc: "Temperature-controlled fridge trucks for perishable cargo.",
    image: "https://media.qiktruck.co.za/banners/fresh-goods.jpg",
  },
  {
    icon: "mdi mdi-package-variant-closed",
    title: "E-commerce & Parcels",
    desc: "Fast, reliable last-mile delivery for your online business.",
    image: "https://media.qiktruck.co.za/banners/handheld-items.jpg",
  },
];

const HERO_WORDS = [
  { text: "Truck", color: "#4f6367" },
  { text: "Bakkie", color: "#FBB13C" },
  { text: "Van", color: "#34D1BF" },
];

class Section extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCategory: "all",
      visibleVehicles: 4,
      heroWordIndex: 0,
      heroFading: false,
    };
    this._heroInterval = null;
  }

  componentDidMount() {
    this._heroInterval = setInterval(() => {
      this.setState({ heroFading: true });
      setTimeout(() => {
        this.setState((prev) => ({
          heroWordIndex: (prev.heroWordIndex + 1) % HERO_WORDS.length,
          heroFading: false,
        }));
      }, 400);
    }, 2500);
  }

  componentWillUnmount() {
    if (this._heroInterval) clearInterval(this._heroInterval);
  }

  showMoreVehicles = () => {
    this.setState({ visibleVehicles: VEHICLE_CATEGORIES.length });
  };

  render() {
    const { visibleVehicles, heroWordIndex, heroFading } = this.state;
    const displayedVehicles = VEHICLE_CATEGORIES.slice(0, visibleVehicles);
    const currentWord = HERO_WORDS[heroWordIndex];

    return (
      <React.Fragment>
        <SEO
          title="Pick Your Truck - Book a Bakkie or Truck Today | QikTruck"
          titleTemplate="QikTruck"
          titleSeparator=" - "
          description="Choose your perfect truck or bakkie for any job. From small bakkies to 34-ton trucks - instant quotes, live tracking, and affordable prices across South Africa."
          image="https://media.qiktruck.co.za/qiktruck-preview-header.png"
          pathname="https://qiktruck.co.za/pick-your-truck"
          twitterUsername="qiktrucksa"
        />

        {/* ═══════ HERO ═══════ */}
        <section className="pyt-hero">
          <div className="pyt-hero-bg">
            <div className="pyt-hero-particles" />
            <Container>
              <Row className="align-items-center pyt-hero-row">
                <Col lg={6} md={12} className="pyt-hero-left">
                  <div className="pyt-hero-badge">🚛 South Africa's #1 On-Demand Delivery</div>
                  <h1 className="pyt-hero-title">
                    Pick Your<br />
                    <span
                      className={"pyt-hero-highlight" + (heroFading ? " pyt-hero-fade-out" : " pyt-hero-fade-in")}
                      style={{ color: currentWord.color }}
                    >
                      {currentWord.text}.
                    </span>
                  </h1>
                  <p className="pyt-hero-subtitle">
                    From a single box to a full house move - get an instant quote, 
                    book a verified driver, and track your delivery in real time.
                  </p>
                  <div className="pyt-hero-actions">
                    <a href="/truck-hire" className="pyt-btn-primary">
                      Get Instant Quote
                      <i className="mdi mdi-arrow-right" style={{ marginLeft: 8 }} />
                    </a>
                    <a href="#how-it-works" className="pyt-btn-ghost">
                      See How It Works
                    </a>
                  </div>
                  <div className="pyt-hero-trust">
                    <div className="pyt-trust-stars">★★★★★</div>
                    <span>Rated 4.8/5 by 10,000+ customers</span>
                  </div>
                </Col>
                <Col lg={6} md={12} className="pyt-hero-right">
                  <div className="pyt-hero-visual">
                    <div className="pyt-vehicle-showcase">
                      <img
                        src="https://media.qiktruck.co.za/3d-4tonclosed.png"
                        alt="QikTruck 4 Ton Delivery Truck"
                        className="pyt-showcase-truck"
                      />
                    </div>
                    <div className="pyt-floating-card pyt-fc-1">
                      <i className="mdi mdi-map-marker-check" style={{ color: "#4f6367", fontSize: 20 }} />
                      <div>
                        <strong>Live Tracking</strong>
                        <small>Real-time GPS updates</small>
                      </div>
                    </div>
                    <div className="pyt-floating-card pyt-fc-2">
                      <i className="mdi mdi-shield-check" style={{ color: "#4f6367", fontSize: 20 }} />
                      <div>
                        <strong>Verified Drivers</strong>
                        <small>Background checked</small>
                      </div>
                    </div>
                    <div className="pyt-floating-card pyt-fc-3">
                      <i className="mdi mdi-clock-fast" style={{ color: "#4f6367", fontSize: 20 }} />
                      <div>
                        <strong>Same Day</strong>
                        <small>Book & move today</small>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </section>

        {/* ═══════ STATS BAR ═══════ */}
        <section className="pyt-stats">
          <Container>
            <Row>
              {STATS.map((s, i) => (
                <Col xs={6} md={3} key={i} className="pyt-stat-item">
                  <div className="pyt-stat-value">{s.value}</div>
                  <div className="pyt-stat-label">{s.label}</div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* ═══════ APP + QUOTE STRIP ═══════ */}
        <section className="pyt-app-strip">
          <Container>
            <Row className="align-items-center justify-content-center">
              <Col xs="auto">
                <div className="pyt-app-strip-inner">
                  <AppDownloadLinks />
                  <a href="/instant-quote" className="pyt-strip-quote-btn">
                    Get a Quote
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ═══════ HOW IT WORKS ═══════ */}
        <section id="how-it-works" className="pyt-how">
          <Container>
            <Row className="justify-content-center text-center mb-5">
              <Col lg={7}>
                <div className="pyt-section-tag">HOW IT WORKS</div>
                <h2 className="pyt-section-title">Book a Truck in 60 Seconds</h2>
                <p className="pyt-section-desc">
                  No calls, no waiting, no haggling. Just pick, book, and go.
                </p>
              </Col>
            </Row>
            <Row>
              {HOW_IT_WORKS.map((step, i) => (
                <Col lg={3} md={6} key={i} className="mb-4">
                  <div className="pyt-step-card">
                    <div className="pyt-step-number" style={{ color: step.color }}>{step.step}</div>
                    <div className="pyt-step-icon" style={{ background: step.bg, color: step.color }}>
                      <i className={step.icon} />
                    </div>
                    <h4 className="pyt-step-title">{step.title}</h4>
                    <p className="pyt-step-desc">{step.desc}</p>
                    {i < HOW_IT_WORKS.length - 1 && (
                      <div className="pyt-step-connector" />
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* ═══════ VEHICLE FLEET ═══════ */}
        <section className="pyt-fleet">
          <Container>
            <Row className="justify-content-center text-center mb-4">
              <Col lg={7}>
                <div className="pyt-section-tag">OUR FLEET</div>
                <h2 className="pyt-section-title">Choose the Right Vehicle</h2>
                <p className="pyt-section-desc">
                  Every vehicle is maintained, insured, and driven by verified professionals.
                </p>
              </Col>
            </Row>
            <Row className="justify-content-center">
              {displayedVehicles.map((v, i) => (
                <Col lg={3} md={4} sm={6} xs={6} key={i} className="mb-4">
                  <a href={v.link} className="pyt-vehicle-card-link">
                    <div className="pyt-vehicle-card">
                      {v.tag && <span className="pyt-vehicle-tag">{v.tag}</span>}
                      <div className="pyt-vehicle-img-wrap">
                        <img src={v.image} alt={v.name} className="pyt-vehicle-img" />
                      </div>
                      <h4 className="pyt-vehicle-name">{v.name}</h4>
                      <p className="pyt-vehicle-tagline">{v.tagline}</p>
                      <div className="pyt-vehicle-meta">
                        <span className="pyt-vehicle-capacity">
                          <i className="mdi mdi-weight" /> {v.capacity}
                        </span>
                      </div>
                      <p className="pyt-vehicle-examples">{v.examples}</p>
                      <div className="pyt-vehicle-footer">
                        <span className="pyt-vehicle-price">{v.price}</span>
                        <span className="pyt-vehicle-book">
                          Book <i className="mdi mdi-arrow-right" />
                        </span>
                      </div>
                    </div>
                  </a>
                </Col>
              ))}
            </Row>
            {visibleVehicles < VEHICLE_CATEGORIES.length && (
              <Row className="justify-content-center mt-2">
                <Col xs="auto">
                  <button
                    className="pyt-btn-secondary"
                    onClick={this.showMoreVehicles}
                  >
                    View All Vehicles
                    <i className="mdi mdi-chevron-down" style={{ marginLeft: 6 }} />
                  </button>
                </Col>
              </Row>
            )}
          </Container>
        </section>

        {/* ═══════ USE CASES ═══════ */}
        <section className="pyt-usecases">
          <Container>
            <Row className="justify-content-center text-center mb-5">
              <Col lg={7}>
                <div className="pyt-section-tag">WHAT WE MOVE</div>
                <h2 className="pyt-section-title">Built for Every Kind of Load</h2>
              </Col>
            </Row>
            <Row>
              {USE_CASES.map((uc, i) => (
                <Col lg={3} md={6} key={i} className="mb-4">
                  <div className="pyt-usecase-card">
                    <div
                      className="pyt-usecase-img"
                      style={{ backgroundImage: `url(${uc.image})` }}
                    >
                      <div className="pyt-usecase-overlay">
                        <i className={uc.icon + " pyt-usecase-icon"} />
                      </div>
                    </div>
                    <div className="pyt-usecase-body">
                      <h5 className="pyt-usecase-title">{uc.title}</h5>
                      <p className="pyt-usecase-desc">{uc.desc}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
            <Row className="justify-content-center mt-3">
              <Col xs="auto">
                <a href="/truck-hire" className="pyt-btn-primary">
                  Get a Quote for Your Load
                </a>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ═══════ CTA BANNER ═══════ */}
        <section className="pyt-cta-banner">
          <Container>
            <Row className="align-items-center">
              <Col lg={7} md={12}>
                <h2 className="pyt-cta-title">
                  This Weekend, Your Move Has a Truck.
                </h2>
                <p className="pyt-cta-body">
                  In <strong>under 2 hours</strong>, a verified QikTruck driver can be at your door
                  with the right vehicle. Transparent pricing. No hidden fees. No stress.
                </p>
                <div className="pyt-cta-actions">
                  <a href="/truck-hire" className="pyt-btn-light">
                    Book Now <i className="mdi mdi-arrow-right" style={{ marginLeft: 6 }} />
                  </a>
                  <a href="https://wa.me/+27663784460" className="pyt-btn-whatsapp" target="_blank" rel="noopener noreferrer">
                    <i className="mdi mdi-whatsapp" style={{ marginRight: 6 }} />
                    Chat on WhatsApp
                  </a>
                </div>
              </Col>
              <Col lg={5} md={12} className="pyt-cta-visual-col">
                <div className="pyt-cta-visual">
                  <img
                    src="https://media.qiktruck.co.za/3d-1tonopen.png"
                    alt="QikTruck Bakkie"
                    className="pyt-cta-truck"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ═══════ TESTIMONIALS ═══════ */}
        <section className="pyt-testimonials">
          <Container>
            <Row className="justify-content-center text-center mb-5">
              <Col lg={7}>
                <div className="pyt-section-tag">TESTIMONIALS</div>
                <h2 className="pyt-section-title">Loved by Thousands</h2>
                <p className="pyt-section-desc">
                  Real reviews from real customers across South Africa.
                </p>
              </Col>
            </Row>
            <Row className="justify-content-center">
              {TESTIMONIALS.map((t, i) => (
                <Col lg={3} md={6} key={i} className="mb-4">
                  <div className="pyt-testimonial-card">
                    <div className="pyt-testi-header">
                      <div className="pyt-testi-avatar">
                        {t.name.charAt(0)}
                      </div>
                      <div>
                        <strong className="pyt-testi-name">{t.name}</strong>
                        <div className="pyt-testi-location">{t.location}</div>
                      </div>
                    </div>
                    <div className="pyt-stars">{"★★★★★"}</div>
                    <p className="pyt-testi-text">"{t.text}"</p>
                    <div className="pyt-testi-vehicle">
                      <i className="mdi mdi-truck" style={{ marginRight: 4 }} />
                      {t.vehicle}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* ═══════ APP DOWNLOAD ═══════ */}
        <section className="pyt-app-download">
          <Container>
            <Row className="align-items-center">
              <Col lg={6} md={12} className="pyt-app-text-col">
                <div className="pyt-section-tag" style={{ color: "#FBB13C" }}>DOWNLOAD THE APP</div>
                <h2 className="pyt-app-title">
                  Book Faster.<br />Track Easier.<br />Move Smarter.
                </h2>
                <p className="pyt-app-desc">
                  Get instant quotes, real-time tracking, and seamless payments -
                  all from the QikTruck app.
                </p>
                <div className="pyt-app-features">
                  <div className="pyt-app-feature">
                    <i className="mdi mdi-check-circle" /> Instant quotes in seconds
                  </div>
                  <div className="pyt-app-feature">
                    <i className="mdi mdi-check-circle" /> Live GPS tracking
                  </div>
                  <div className="pyt-app-feature">
                    <i className="mdi mdi-check-circle" /> Secure in-app payments
                  </div>
                  <div className="pyt-app-feature">
                    <i className="mdi mdi-check-circle" /> 24/7 customer support
                  </div>
                </div>
                <div className="pyt-app-downloads">
                  <AppDownloadLinks />
                </div>
              </Col>
              <Col lg={6} md={12} className="pyt-app-img-col">
                <div className="pyt-phone-mockup">
                  <img
                    src="https://media.qiktruck.co.za/customer-app.png"
                    alt="QikTruck Mobile App"
                    className="pyt-phone-img"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ═══════ FINAL CTA ═══════ */}
        <section className="pyt-final-cta">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={8}>
                <h2 className="pyt-final-title">Ready to Move?</h2>
                <p className="pyt-final-desc">
                  Pick your truck, get an instant quote, and book in under 60 seconds.
                  Because moving shouldn't be a mission.
                </p>
                <a href="/truck-hire" className="pyt-btn-primary pyt-btn-xl">
                  Get Your Free Quote Now
                  <i className="mdi mdi-arrow-right" style={{ marginLeft: 10 }} />
                </a>
                <p className="pyt-final-note">
                  No card required · Instant pricing · Cancel anytime
                </p>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ═══════ SOCIAL BAR ═══════ */}
        {/* <section className="pyt-social-bar">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={6}>
                <div className="pyt-social-icons">
                  <a href="https://www.facebook.com/QikTruck" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <img src="https://media.qiktruck.co.za/facebook-bg-min.png" alt="Facebook" className="pyt-social-icon" />
                  </a>
                  <a href="https://www.instagram.com/qiktruck/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <img src="https://media.qiktruck.co.za/instagram-bg-min.png" alt="Instagram" className="pyt-social-icon" />
                  </a>
                  <a href="https://twitter.com/QikTruckSA" target="_blank" rel="noopener noreferrer" aria-label="X">
                    <img src="https://media.qiktruck.co.za/twitter-bg-min.png" alt="X" className="pyt-social-icon" />
                  </a>
                  <a href="https://www.tiktok.com/@qiktruck.co.za" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                    <img src="https://media.qiktruck.co.za/tiktok-bg-min.png" alt="TikTok" className="pyt-social-icon" />
                  </a>
                  <a href="https://www.linkedin.com/company/qiktruck/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <img src="https://media.qiktruck.co.za/linkedin-bg-min.png" alt="LinkedIn" className="pyt-social-icon" />
                  </a>
                  <a href="https://www.youtube.com/channel/UC4OnYSqaDN7u3tA2mYIFzrQ" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                    <img src="https://media.qiktruck.co.za/youtube.webp" alt="YouTube" className="pyt-social-icon" />
                  </a>
                </div>
                <p className="pyt-footer-copy">© {new Date().getFullYear()} QikTruck Pty Ltd. South Africa.</p>
                <p className="pyt-footer-links">
                  <a href="/terms">Terms & Conditions</a>
                  <span className="pyt-dot">·</span>
                  <a href="/privacy">Privacy Policy</a>
                  <span className="pyt-dot">·</span>
                  <a href="mailto:support@qiktruck.co.za">support@qiktruck.co.za</a>
                </p>
              </Col>
            </Row>
          </Container>
        </section> */}

        {/* ═══════ STYLES ═══════ */}
        <style jsx>{`
          /* ── Animations ── */
          @keyframes pytFloat {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-12px); }
          }
          @keyframes pytFadeUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes pytPulse {
            0%, 100% { box-shadow: 0 0 0 0 rgba(79, 99, 103, 0.3); }
            50% { box-shadow: 0 0 0 16px rgba(79, 99, 103, 0); }
          }
          @keyframes pytSlideRight {
            from { opacity: 0; transform: translateX(-20px); }
            to { opacity: 1; transform: translateX(0); }
          }
          @keyframes pytShimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }
          @keyframes pytWordIn {
            from { opacity: 0; transform: translateY(16px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes pytWordOut {
            from { opacity: 1; transform: translateY(0); }
            to { opacity: 0; transform: translateY(-16px); }
          }

          /* ── Global ── */
          .pyt-hero, .pyt-stats, .pyt-how, .pyt-fleet,
          .pyt-usecases, .pyt-cta-banner, .pyt-testimonials,
          .pyt-app-download, .pyt-final-cta, .pyt-social-bar {
            font-family: 'Poppins', sans-serif;
          }
          .pyt-section-tag {
            display: inline-block;
            font-size: 0.75rem;
            font-weight: 700;
            letter-spacing: 2.5px;
            color: #4f6367;
            text-transform: uppercase;
            margin-bottom: 12px;
          }
          .pyt-section-title {
            font-size: 2.4rem;
            font-weight: 800;
            color: #343a40;
            line-height: 1.15;
            margin-bottom: 12px;
          }
          .pyt-section-desc {
            font-size: 1.05rem;
            color: #6c757d;
            line-height: 1.6;
            max-width: 540px;
            margin: 0 auto;
          }

          /* ── Hero ── */
          .pyt-hero {
            background: linear-gradient(160deg, #f6f6f6 0%, #eef2f3 30%, #ffffff 70%, #f6f6f6 100%);
            position: relative;
            overflow: hidden;
            min-height: 92vh;
            display: flex;
            align-items: center;
          }
          .pyt-hero-bg {
            width: 100%;
            position: relative;
          }
          .pyt-hero-particles {
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background:
              radial-gradient(circle at 20% 80%, rgba(79, 99, 103, 0.05) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(251, 177, 60, 0.06) 0%, transparent 50%),
              radial-gradient(circle at 50% 50%, rgba(79, 99, 103, 0.02) 0%, transparent 70%);
            pointer-events: none;
          }
          .pyt-hero-row {
            min-height: 80vh;
            padding: 100px 0 60px;
          }
          .pyt-hero-left {
            animation: pytFadeUp 0.8s ease-out;
          }
          .pyt-hero-badge {
            display: inline-block;
            background: rgba(79, 99, 103, 0.1);
            color: #4f6367;
            font-size: 0.8rem;
            font-weight: 600;
            padding: 8px 18px;
            border-radius: 50px;
            margin-bottom: 24px;
            letter-spacing: 0.3px;
          }
          .pyt-hero-title {
            font-size: 4.5rem;
            font-weight: 900;
            color: #343a40;
            line-height: 1.05;
            margin-bottom: 20px;
            letter-spacing: -1px;
          }
          .pyt-hero-highlight {
            color: #4f6367;
            position: relative;
            display: inline-block;
            transition: color 0.4s ease;
          }
          .pyt-hero-fade-in {
            animation: pytWordIn 0.4s ease forwards;
          }
          .pyt-hero-fade-out {
            animation: pytWordOut 0.4s ease forwards;
          }
          .pyt-hero-highlight::after {
            content: '';
            position: absolute;
            bottom: 4px;
            left: 0;
            width: 100%;
            height: 12px;
            background: currentColor;
            opacity: 0.15;
            border-radius: 4px;
            z-index: -1;
            transition: background 0.4s ease;
          }
          .pyt-hero-subtitle {
            font-size: 1.15rem;
            color: #4e5154;
            line-height: 1.7;
            margin-bottom: 32px;
            max-width: 480px;
          }
          .pyt-hero-actions {
            display: flex;
            gap: 14px;
            flex-wrap: wrap;
            margin-bottom: 28px;
          }
          .pyt-btn-primary {
            display: inline-flex;
            align-items: center;
            padding: 14px 32px;
            background: #4f6367;
            color: #ffffff;
            font-size: 0.95rem;
            font-weight: 700;
            border-radius: 12px;
            text-decoration: none;
            transition: all 0.25s ease;
            border: 2px solid #4f6367;
          }
          .pyt-btn-primary:hover {
            background: #3d5053;
            border-color: #3d5053;
            color: #ffffff;
            text-decoration: none;
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(79, 99, 103, 0.25);
          }
          .pyt-btn-xl {
            padding: 18px 48px;
            font-size: 1.1rem;
            border-radius: 14px;
          }
          .pyt-btn-ghost {
            display: inline-flex;
            align-items: center;
            padding: 14px 32px;
            background: transparent;
            color: #4f6367;
            font-size: 0.95rem;
            font-weight: 600;
            border-radius: 12px;
            text-decoration: none;
            border: 2px solid #d1d5db;
            transition: all 0.25s ease;
          }
          .pyt-btn-ghost:hover {
            border-color: #4f6367;
            background: rgba(79, 99, 103, 0.04);
            color: #4f6367;
            text-decoration: none;
          }
          .pyt-btn-secondary {
            display: inline-flex;
            align-items: center;
            padding: 12px 28px;
            background: transparent;
            color: #4f6367;
            font-size: 0.9rem;
            font-weight: 600;
            border-radius: 12px;
            border: 2px solid #4f6367;
            cursor: pointer;
            transition: all 0.25s ease;
          }
          .pyt-btn-secondary:hover {
            background: #4f6367;
            color: #ffffff;
          }
          .pyt-hero-trust {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 0.85rem;
            color: #6c757d;
          }
          .pyt-trust-stars {
            color: #FBB13C;
            font-size: 1rem;
            letter-spacing: 1px;
          }

          /* Hero Visual */
          .pyt-hero-right {
            animation: pytFadeUp 1s ease-out 0.2s both;
          }
          .pyt-hero-visual {
            position: relative;
            padding: 40px 0;
          }
          .pyt-vehicle-showcase {
            position: relative;
            text-align: center;
          }
          .pyt-showcase-truck {
            width: 100%;
            max-width: 420px;
            filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.12));
            animation: pytFloat 4s ease-in-out infinite;
          }
          .pyt-floating-card {
            position: absolute;
            background: #ffffff;
            border-radius: 14px;
            padding: 14px 18px;
            display: flex;
            align-items: center;
            gap: 12px;
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
            z-index: 10;
            animation: pytSlideRight 0.6s ease-out both;
          }
          .pyt-floating-card strong {
            display: block;
            font-size: 0.82rem;
            color: #343a40;
          }
          .pyt-floating-card small {
            font-size: 0.72rem;
            color: #adb5bd;
          }
          .pyt-fc-1 {
            top: 20px; right: 0;
            animation-delay: 0.5s;
          }
          .pyt-fc-2 {
            bottom: 60px; left: -10px;
            animation-delay: 0.8s;
          }
          .pyt-fc-3 {
            bottom: 0; right: 30px;
            animation-delay: 1.1s;
          }

          /* ── Stats Bar ── */
          .pyt-stats {
            background: #4f6367;
            padding: 36px 0;
          }
          .pyt-stat-item {
            text-align: center;
            padding: 12px 8px;
          }
          .pyt-stat-value {
            font-size: 1.8rem;
            font-weight: 800;
            color: #ffffff;
            line-height: 1;
            margin-bottom: 4px;
          }
          .pyt-stat-label {
            font-size: 0.82rem;
            color: rgba(255, 255, 255, 0.7);
            font-weight: 500;
          }

          /* ── App + Quote Strip ── */
          .pyt-app-strip {
            padding: 28px 0;
            background: #f8f9fa;
          }
          .pyt-app-strip-inner {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 20px;
            flex-wrap: wrap;
          }
          .pyt-strip-quote-btn {
            display: inline-flex;
            align-items: center;
            padding: 14px 36px;
            background: #FBB13C;
            color: #343a40;
            font-size: 0.95rem;
            font-weight: 700;
            border-radius: 10px;
            text-decoration: none;
            transition: all 0.25s ease;
            border: 2px solid #FBB13C;
          }
          .pyt-strip-quote-btn:hover {
            background: #e9a020;
            border-color: #e9a020;
            color: #343a40;
            text-decoration: none;
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(251, 177, 60, 0.3);
          }

          /* ── How It Works ── */
          .pyt-how {
            padding: 80px 0 60px;
            background: #ffffff;
          }
          .pyt-step-card {
            text-align: center;
            padding: 24px 16px;
            position: relative;
          }
          .pyt-step-number {
            font-size: 0.7rem;
            font-weight: 800;
            color: #4f6367;
            letter-spacing: 1px;
            margin-bottom: 16px;
          }
          .pyt-step-icon {
            width: 68px;
            height: 68px;
            background: rgba(79, 99, 103, 0.12);
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 18px;
            font-size: 1.8rem;
            color: #4f6367;
          }
          .pyt-step-title {
            font-size: 1.05rem;
            font-weight: 700;
            color: #343a40;
            margin-bottom: 8px;
          }
          .pyt-step-desc {
            font-size: 0.88rem;
            color: #6c757d;
            line-height: 1.5;
            margin-bottom: 0;
          }
          .pyt-step-connector {
            display: none;
          }

          /* ── Fleet / Vehicle Cards ── */
          .pyt-fleet {
            padding: 80px 0;
            background: #f8f9fa;
          }
          .pyt-vehicle-card-link {
            text-decoration: none;
            display: block;
            height: 100%;
          }
          .pyt-vehicle-card-link:hover {
            text-decoration: none;
          }
          .pyt-vehicle-card {
            background: #ffffff;
            border-radius: 16px;
            padding: 22px 18px 18px;
            text-align: center;
            box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04);
            transition: all 0.3s ease;
            position: relative;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            border: 2px solid transparent;
          }
          .pyt-vehicle-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
            border-color: #4f6367;
          }
          .pyt-vehicle-tag {
            position: absolute;
            top: 14px;
            right: 14px;
            font-size: 0.6rem;
            font-weight: 800;
            padding: 4px 10px;
            border-radius: 50px;
            letter-spacing: 0.8px;
            color: #ffffff;
            background: #4f6367;
          }
          .pyt-vehicle-img-wrap {
            width: 100%;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 14px;
          }
          .pyt-vehicle-img {
            max-width: 100%;
            max-height: 110px;
            object-fit: contain;
            transition: transform 0.3s ease;
          }
          .pyt-vehicle-card:hover .pyt-vehicle-img {
            transform: scale(1.08);
          }
          .pyt-vehicle-name {
            font-size: 0.95rem;
            font-weight: 700;
            color: #343a40;
            margin-bottom: 2px;
          }
          .pyt-vehicle-tagline {
            font-size: 0.78rem;
            color: #6c757d;
            margin-bottom: 8px;
          }
          .pyt-vehicle-meta {
            display: flex;
            justify-content: center;
            gap: 10px;
            margin-bottom: 8px;
          }
          .pyt-vehicle-capacity {
            font-size: 0.72rem;
            color: #4f6367;
            background: #eef2f3;
            padding: 3px 10px;
            border-radius: 50px;
            font-weight: 600;
          }
          .pyt-vehicle-examples {
            font-size: 0.72rem;
            color: #adb5bd;
            line-height: 1.4;
            margin-bottom: 14px;
            flex: 1;
          }
          .pyt-vehicle-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding-top: 12px;
            border-top: 1px solid #e9ecef;
            margin-top: auto;
          }
          .pyt-vehicle-price {
            font-size: 0.95rem;
            font-weight: 800;
            color: #4f6367;
          }
          .pyt-vehicle-book {
            font-size: 0.8rem;
            font-weight: 600;
            color: #4f6367;
            transition: transform 0.2s ease;
          }
          .pyt-vehicle-card:hover .pyt-vehicle-book {
            transform: translateX(4px);
          }

          /* ── Use Cases ── */
          .pyt-usecases {
            padding: 80px 0;
            background: #ffffff;
          }
          .pyt-usecase-card {
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
            transition: all 0.3s ease;
            height: 100%;
            background: #fff;
          }
          .pyt-usecase-card:hover {
            transform: translateY(-6px);
            box-shadow: 0 12px 36px rgba(0, 0, 0, 0.1);
          }
          .pyt-usecase-img {
            height: 160px;
            background-size: cover;
            background-position: center;
            position: relative;
          }
          .pyt-usecase-overlay {
            position: absolute;
            inset: 0;
            background: linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.4) 100%);
            display: flex;
            align-items: flex-end;
            padding: 16px;
          }
          .pyt-usecase-icon {
            font-size: 1.6rem;
            color: #ffffff;
          }
          .pyt-usecase-body {
            padding: 18px;
          }
          .pyt-usecase-title {
            font-size: 1rem;
            font-weight: 700;
            color: #343a40;
            margin-bottom: 6px;
          }
          .pyt-usecase-desc {
            font-size: 0.85rem;
            color: #6c757d;
            line-height: 1.5;
            margin-bottom: 0;
          }

          /* ── CTA Banner ── */
          .pyt-cta-banner {
            padding: 60px 0;
            background: linear-gradient(135deg, #343a40 0%, #4f6367 60%, #6b8588 100%);
            position: relative;
            overflow: hidden;
          }
          .pyt-cta-banner::before {
            content: '';
            position: absolute;
            top: -50%;
            right: -20%;
            width: 600px;
            height: 600px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.03);
          }
          .pyt-cta-title {
            font-size: 2.4rem;
            font-weight: 800;
            color: #ffffff;
            margin-bottom: 16px;
            line-height: 1.2;
          }
          .pyt-cta-body {
            font-size: 1.05rem;
            color: rgba(255, 255, 255, 0.85);
            line-height: 1.7;
            margin-bottom: 28px;
            max-width: 520px;
          }
          .pyt-cta-actions {
            display: flex;
            gap: 14px;
            flex-wrap: wrap;
          }
          .pyt-btn-light {
            display: inline-flex;
            align-items: center;
            padding: 14px 32px;
            background: #ffffff;
            color: #4f6367;
            font-size: 0.95rem;
            font-weight: 700;
            border-radius: 12px;
            text-decoration: none;
            transition: all 0.25s ease;
          }
          .pyt-btn-light:hover {
            background: #f8fafe;
            color: #4f6367;
            text-decoration: none;
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
          }
          .pyt-btn-whatsapp {
            display: inline-flex;
            align-items: center;
            padding: 14px 28px;
            background: #25D366;
            color: #ffffff;
            font-size: 0.95rem;
            font-weight: 600;
            border-radius: 12px;
            text-decoration: none;
            transition: all 0.25s ease;
          }
          .pyt-btn-whatsapp:hover {
            background: #20BD5A;
            color: #ffffff;
            text-decoration: none;
            transform: translateY(-2px);
          }
          .pyt-cta-visual-col {
            text-align: center;
          }
          .pyt-cta-truck {
            max-width: 320px;
            width: 100%;
            filter: drop-shadow(0 16px 32px rgba(0, 0, 0, 0.2));
            animation: pytFloat 5s ease-in-out infinite;
          }

          /* ── Testimonials ── */
          .pyt-testimonials {
            padding: 80px 0;
            background: #f8f9fa;
          }
          .pyt-testimonial-card {
            background: #ffffff;
            border-radius: 16px;
            padding: 24px 20px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 16px rgba(0, 0, 0, 0.04);
            height: 100%;
            display: flex;
            flex-direction: column;
            transition: all 0.3s ease;
          }
          .pyt-testimonial-card:hover {
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          }
          .pyt-testi-header {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 14px;
          }
          .pyt-testi-avatar {
            width: 42px;
            height: 42px;
            border-radius: 50%;
            background: linear-gradient(135deg, #4f6367, #6b8588);
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.1rem;
            font-weight: 700;
            flex-shrink: 0;
          }
          .pyt-testi-name {
            font-size: 0.88rem;
            color: #343a40;
          }
          .pyt-testi-location {
            font-size: 0.75rem;
            color: #adb5bd;
          }
          .pyt-stars {
            color: #FBB13C;
            font-size: 0.9rem;
            letter-spacing: 2px;
            margin-bottom: 12px;
          }
          .pyt-testi-text {
            font-size: 0.88rem;
            color: #4e5154;
            line-height: 1.6;
            flex: 1;
            margin-bottom: 14px;
          }
          .pyt-testi-vehicle {
            font-size: 0.75rem;
            color: #4f6367;
            background: #eef2f3;
            display: inline-flex;
            align-items: center;
            padding: 4px 10px;
            border-radius: 50px;
            font-weight: 600;
            align-self: flex-start;
          }

          /* ── App Download ── */
          .pyt-app-download {
            padding: 80px 0;
            background: linear-gradient(160deg, #343a40, #4f6367);
            color: #ffffff;
            overflow: hidden;
          }
          .pyt-app-title {
            font-size: 2.4rem;
            font-weight: 800;
            color: #ffffff;
            line-height: 1.2;
            margin-bottom: 16px;
          }
          .pyt-app-desc {
            font-size: 1rem;
            color: rgba(255, 255, 255, 0.75);
            line-height: 1.6;
            margin-bottom: 24px;
            max-width: 420px;
          }
          .pyt-app-features {
            margin-bottom: 28px;
          }
          .pyt-app-feature {
            font-size: 0.9rem;
            color: rgba(255, 255, 255, 0.85);
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            gap: 10px;
          }
          .pyt-app-feature .mdi {
            color: #34D1BF;
            font-size: 1.1rem;
          }
          .pyt-app-downloads {
            margin-top: 8px;
          }
          .pyt-app-img-col {
            text-align: center;
          }
          .pyt-phone-mockup {
            position: relative;
            display: inline-block;
          }
          .pyt-phone-img {
            max-width: 280px;
            width: 100%;
            border-radius: 24px;
            box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
          }

          /* ── Final CTA ── */
          .pyt-final-cta {
            padding: 80px 0;
            background: #ffffff;
          }
          .pyt-final-title {
            font-size: 2.8rem;
            font-weight: 900;
            color: #343a40;
            margin-bottom: 16px;
          }
          .pyt-final-desc {
            font-size: 1.1rem;
            color: #6c757d;
            line-height: 1.7;
            margin-bottom: 32px;
            max-width: 560px;
            margin-left: auto;
            margin-right: auto;
          }
          .pyt-final-note {
            margin-top: 18px;
            font-size: 0.82rem;
            color: #adb5bd;
          }

          /* ── Social Bar ── */
          .pyt-social-bar {
            padding: 40px 0 30px;
            background: #4f6367;
            color: #ffffff;
          }
          .pyt-social-icons {
            display: flex;
            justify-content: center;
            gap: 16px;
            margin-bottom: 20px;
          }
          .pyt-social-icon {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            transition: all 0.25s ease;
            filter: brightness(0.9);
          }
          .pyt-social-icon:hover {
            transform: translateY(-3px) scale(1.1);
            filter: brightness(1);
          }
          .pyt-footer-copy {
            font-size: 0.82rem;
            color: rgba(255, 255, 255, 0.6);
            margin-bottom: 6px;
          }
          .pyt-footer-links {
            font-size: 0.78rem;
          }
          .pyt-footer-links a {
            color: rgba(255, 255, 255, 0.5);
            text-decoration: none;
            transition: color 0.2s;
          }
          .pyt-footer-links a:hover {
            color: #34D1BF;
          }
          .pyt-dot {
            margin: 0 8px;
            color: rgba(255, 255, 255, 0.25);
          }

          /* ═══ Responsive ═══ */
          @media (max-width: 992px) {
            .pyt-hero-title { font-size: 3.5rem; }
            .pyt-hero-row { min-height: auto; padding: 90px 0 40px; }
            .pyt-hero-right { margin-top: 40px; }
            .pyt-floating-card { display: none; }
            .pyt-section-title { font-size: 2rem; }
            .pyt-cta-title { font-size: 2rem; }
            .pyt-app-title { font-size: 2rem; }
            .pyt-final-title { font-size: 2.2rem; }
          }
          @media (max-width: 768px) {
            .pyt-hero { min-height: auto; }
            .pyt-hero-title { font-size: 2.8rem; }
            .pyt-hero-subtitle { font-size: 1rem; }
            .pyt-hero-row { padding: 80px 0 30px; }
            .pyt-stats { padding: 24px 0; }
            .pyt-stat-value { font-size: 1.4rem; }
            .pyt-how, .pyt-fleet, .pyt-usecases,
            .pyt-testimonials, .pyt-app-download, .pyt-final-cta {
              padding: 50px 0;
            }
            .pyt-section-title { font-size: 1.7rem; }
            .pyt-cta-title { font-size: 1.7rem; }
            .pyt-cta-visual-col { margin-top: 30px; }
            .pyt-cta-truck { max-width: 240px; }
            .pyt-app-title { font-size: 1.7rem; }
            .pyt-app-img-col { margin-top: 30px; }
            .pyt-final-title { font-size: 1.8rem; }
            .pyt-btn-xl { padding: 14px 32px; font-size: 1rem; }
          }
          @media (max-width: 576px) {
            .pyt-hero-title { font-size: 2.2rem; }
            .pyt-hero-badge { font-size: 0.7rem; padding: 6px 14px; }
            .pyt-hero-actions { flex-direction: column; }
            .pyt-btn-primary, .pyt-btn-ghost { width: 100%; justify-content: center; }
            .pyt-showcase-truck { max-width: 280px; }
            .pyt-vehicle-img-wrap { height: 90px; }
            .pyt-vehicle-img { max-height: 80px; }
            .pyt-vehicle-name { font-size: 0.82rem; }
            .pyt-vehicle-tagline { font-size: 0.7rem; }
            .pyt-vehicle-price { font-size: 0.82rem; }
            .pyt-vehicle-examples { font-size: 0.65rem; }
            .pyt-cta-actions { flex-direction: column; }
            .pyt-btn-light, .pyt-btn-whatsapp { width: 100%; justify-content: center; }
            .pyt-phone-img { max-width: 200px; }
            .pyt-section-title { font-size: 1.5rem; }
            .pyt-final-title { font-size: 1.6rem; }
          }
        `}</style>
      </React.Fragment>
    );
  }
}

export default Section;
